module.exports = function (file) {
  return require('@/views/' + file).default;
};